import { render, staticRenderFns } from "./ADSEnvironmentGroup.vue?vue&type=template&id=84ec2d38&scoped=true"
import script from "./ADSEnvironmentGroup.vue?vue&type=script&lang=js"
export * from "./ADSEnvironmentGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ec2d38",
  null
  
)

export default component.exports